/* tslint:disable:max-line-length */
import gql from 'graphql-tag';

export const DeleteGroups = gql`
  mutation DeleteGroups($ids: [ID!]!) {
    deleteGroups(ids: $ids)
  }
`;
